type ISO8601 = string;

export type ResampleJobRequest = {
	defaultIncluded: boolean;
	deltaTimeSeconds?: number;
	endTime: ISO8601;
	sensorIds: string[];
	sensorQuery: Record<string, unknown>;
	startTime: ISO8601;
};

export type ResampleJobResponse = {
	jobId: string;
	shadow: string;
};

export enum ResampleVerificationFields {
	collectionInterval = 'collectionInterval',
	dataSourceType = 'dataSourceType',
	dataSourceId = 'dataSourceId',
	sensorTable = 'sensorTable',
	sensorIdField = 'sensorIdField',
	tagValue = 'tagValue',
	sensorDateField = 'sensorDateField',
	sensorChannelField = 'sensorChannelField',
}
